import React, { PureComponent } from "react";
import CustomScroll from "react-custom-scroll";

import {
  PieChart,
  Pie,
  Sector,
  Cell,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

const renderLegend = (props) => {
  const { payload, showTotal } = props;
  const sum = payload
    .map((item) => item.payload.value)
    .reduce((a, b) => a + b, 0);
  return (
    <div style={payload.length > 8 ? { height: "300px" } : {}}>
      {showTotal && (
        <div className="legend-total">
          <span className="name">TOTAL</span>
          <span className="value">{sum}</span>
        </div>
      )}
      <CustomScroll heightRelativeToParent="100%" allowOuterScroll={true}>
        <ul className="legend-items">
          {payload.map((entry, index) => (
            <li style={{ color: entry.payload.fill }} key={`item-${index}`}>
              <span className="name">{entry.value}</span>
              <span className="count">{entry.payload.value}</span>
              <span className="value">
                {Number(
                  (
                    (entry.payload.percent ? entry.payload.percent : 0) * 100
                  ).toFixed(2)
                )}
                %
              </span>
            </li>
          ))}
        </ul>
      </CustomScroll>
    </div>
  );
};

const renderActiveShape = (props, _) => {
  const {
    cx,
    cy,
    innerRadius,
    outerRadius,
    startAngle,
    endAngle,
    fill,
    payload,
  } = props;
  return (
    <g>
      <text
        className="name"
        x={cx}
        y={cy + 5}
        dy={8}
        textAnchor="middle"
        fill="#00257b"
      >
        {payload.value}
      </text>
      <text
        className="total"
        x={cx}
        y={cy + 19}
        dy={8}
        textAnchor="middle"
        fill="#00257b"
      >
        {_.Total}
      </text>
      <Sector
        cx={cx}
        cy={cy}
        innerRadius={innerRadius}
        outerRadius={outerRadius}
        startAngle={startAngle}
        endAngle={endAngle}
        fill={fill}
      />

      <Sector
        className="shadow-circle"
        cx={cx}
        cy={cy}
        startAngle={0}
        endAngle={360}
        innerRadius={outerRadius - 25}
        outerRadius={outerRadius - 24}
        fill="#dedede"
      />
    </g>
  );
};

export default class PieChartWithPaddingAngle extends PureComponent {
  state = { activeIndex: 0 };

  onPieEnter = (e, i) => {
    this.setState({ activeIndex: i });
  };

  render() {
    const LegendStyle = {
      left: "35%",
      width: "65%",
    };
    const {
      data,
      COLORS = [],
      fill,
      showTotal,
      _,
      showLegend = true,
      showActiveShape = false,
      angles = {},
      tooltip = true,
    } = this.props;
    const {
      cx = "15%",
      cy = "50%",
      innerRadius = "45%",
      outerRadius = "65%",
      paddingAngle = 0,
    } = angles;
    return (
      <div className="widget-card">
        <ResponsiveContainer
          className="widget-recharts-responsive-container"
          width={"99%"}
          height={"99%"}
        >
          <PieChart>
            <Pie
              data={data}
              _={_}
              cx={cx}
              cy={cy}
              innerRadius={innerRadius}
              outerRadius={outerRadius}
              fill={fill}
              paddingAngle={paddingAngle}
              dataKey="value"
              {...(showActiveShape
                ? { activeShape: (props) => renderActiveShape(props, _) }
                : {})}
              activeIndex={this.state.activeIndex}
              onMouseEnter={this.onPieEnter}
            >
              {COLORS.length > 0 &&
                data.length > 0 &&
                data.map((entry, index) => (
                  <Cell
                    key={`cell-${index}`}
                    fill={COLORS[index % COLORS.length]}
                  />
                ))}
            </Pie>
            {tooltip && <Tooltip />}

            {/* <Legend content={renderLegend} /> */}
            {showLegend && (
              <Legend
                content={renderLegend}
                showTotal={showTotal}
                // align="right"
                verticalAlign="middle"
                layout="vertical"
                wrapperStyle={LegendStyle}
                iconSize={10}
                iconType="circle"
              />
            )}
          </PieChart>
        </ResponsiveContainer>
      </div>
    );
  }
}
